import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=c6c5ef5c&scoped=true"
import script from "./Default.vue?vue&type=script&lang=ts"
export * from "./Default.vue?vue&type=script&lang=ts"
import style0 from "./Default.vue?vue&type=style&index=0&id=c6c5ef5c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c5ef5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6c5ef5c')) {
      api.createRecord('c6c5ef5c', component.options)
    } else {
      api.reload('c6c5ef5c', component.options)
    }
    module.hot.accept("./Default.vue?vue&type=template&id=c6c5ef5c&scoped=true", function () {
      api.rerender('c6c5ef5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/Default.vue"
export default component.exports